import { FilterFilled } from '@ant-design/icons';
import {
  Checkbox,
  Col,
  Collapse,
  Divider,
  Modal,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import CheckableTag from 'antd/es/tag/CheckableTag';
import { CollapseProps, Table } from 'antd/lib';
import AllocateApi from 'apis/AllocateApi';
import * as XLSX from 'xlsx';
import {
  EyeIcon,
  ChevronDown,
  ChevronUp,
  DownloadIcon,
  FilterIcon,
  RedFlag,
  CheckIcon,
  Remove,
  FilterIcon2,
  EyeIcon2,
  CheckGray,
} from 'assets/svg';
import Button from 'components/Button';
import { PORTFOLIO_STATUS } from 'constants/portfolioStatus';
import { STATUS } from 'constants/reponseStatus';
import { useUser } from 'contexts/User';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useRef, useState } from 'react';
import { Mutation, useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import CartApi from 'apis/CartApi';
import convertStatusApproveOrder from 'constants/approveOrderStatus';
import moment from 'moment';
import { openNotificationWithIcon } from 'utils/notification';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { headerRow } from 'constants/exportFile';
import { isNumber } from 'lodash';
import formatNumber from 'utils/formatNumber';
import DropdownComponent from 'components/DropdownComponent';

type FixedType = 'left' | 'right' | boolean;
interface IProps {
  cart: any;
}
export default function PerShop(props: IProps): JSX.Element {
  const capitalLineProduct = [
    {
      tuXman: 'Tổng',
      tu: 7,
      sLMau: 7,
      minPlan: 1134,
      minCur: 20,
      minApproval: 10,
      maxCur: 20,
      maxApproval: 2,
    },
    {
      tuXman: 'Dây chuyền Platin',
      dVi: 'Cây dây',
      tu: 5,
      sLMau: 5,
      minPlan: 5,
      minCur: 50,
      minApproval: 50,
      maxPlan: 5,
      maxCur: 50,
      maxApproval: 5,
    },
    {
      tuXman: 'Dây chuyền 9999',
      dVi: 'Khay',
      tu: 1,
      sLMau: 1,
      minPlan: 1,
      minCur: 50,
      minApproval: 50,
      maxPlan: 1,
      maxCur: 50,
      maxApproval: 1,
    },
    {
      tuXman: 'Nhẫn vàng',
      tu: 1,
      sLMau: 1,
      minPlan: 1,
      minCur: 50,
      minApproval: 50,
      maxPlan: 1,
      maxCur: 50,
      maxApproval: 1,
    },
  ];

  const { cart } = props;

  const history = useHistory();
  const { Option } = Select;
  const { user } = useUser();

  const [selectedTags, setSelectedTags] = useState<string>();
  const [bstSelected, setBST] = useState<any>();
  const [checkAll, setCheckAll] = useState<boolean>(false);
  const [listShopSelected, setListShopSelected] = useState<any[]>([]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [isApprove, setIsApprove] = useState<boolean>(false);
  const [isManyApprove, setIsManyApprove] = useState<boolean>(false);
  const [shopHandle, setShopHandle] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [exportAction, setExportAction] = useState<boolean>(false);
  const [dataExport, setDataExport] = useState<any>();
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const [lstAllShops, setLstAllShops] = useState<any>();

  const userParams = {
    page: page.toString(),
    page_size: page_size.toString(),
    plant_code: user?.plantCode,
    cart_code: cart.cart_code,
    ...(formSubmitParams && formSubmitParams),
  };

  const mutationFunction = () =>
    user?.plantCode == 1000
      ? (params: any) => CartApi.getCartCHT_view(params) //hội sở
      : (params: any) => CartApi.getListOrderShop(params); //chi nhánh

  const {
    data: lstAllocation,
    isLoading: getAllocationLoading,
    mutate: refetch,
  } = useMutation(['getShops', page], mutationFunction(), {
    onSuccess: (response: any) => {
      // getAllShops({ ...userParams, page_size: lstAllocation?.total });
    },
    onError: (error) => {
      openNotificationWithIcon('error', `Lỗi tải xuống`);
    },
  });

  const { mutate: getAllShops, isLoading: isLoadingAllShop } = useMutation(
    ['getAllShops', page],
    mutationFunction(),
    {
      onSuccess: async (response: any, variable: any) => {
        if (response.status === STATUS.SUCCESS) {
          console.log('fetch');
          setLstAllShops(response.data);
          if (variable.action === 'export') {
            //exportFileExcel(response.data);
            const listShop = [];
            if (response.data.length > 0) {
              for (let i = 0; i < response.data.length; i++) {
                listShop.push(response.data[i].ma_cua_hang);
              }
            } else {
              for (let i = 0; i < response.data.data.length; i++) {
                listShop.push(response.data.data[i].ma_cua_hang);
              }
            }
            if (listShop.length > 0) {
              let listData = [];
              const getData = [];
              for (let i = 0; i < listShop.length; i++) {
                let param = [];
                listData.push(listShop[i]);
                if (listData.length == 1 || i == listShop.length - 1) {
                  openNotificationWithIcon(
                    'warning',
                    `Đang tải cửa hàng: ${listData}`
                  );
                  setIsLoading(true);
                  param = await exportMultiStore({
                    listShop: listData,
                    cart_code: cart.cart_code,
                  });
                  if (param.length < 1) {
                    openNotificationWithIcon(
                      'error',
                      `Các cửa hàng: ${listData} không có data`
                    );
                  } else if (param.length > 0) {
                    for (let j = 0; j < param.length; j++) {
                      getData.push(param[j]);
                    }
                    openNotificationWithIcon(
                      'success',
                      `Tải cửa hàng: ${listData} thành công`
                    );
                  }
                  listData = [];
                }
                if (i == listShop.length - 1) setExportAction(true);
              }
              setDataExport(getData);
            }
          }
          if (variable.action === 'checkAll') {
            const updatedData = response.data.filter(
              (value: any) => value.order_status == 1
            );

            if (updatedData?.length == 0) {
              openNotificationWithIcon(
                'error',
                `Không có cửa hàng nào chờ duyệt`
              );
              setCheckAll(false);
              setListShopSelected([]);
            } else {
              setCheckAll(true);
              setListShopSelected(updatedData);
            }
          }
        }
      },
      onError: (error) => {
        openNotificationWithIcon('warning', `Không có dữ liệu`);
      },
    }
  );

  useEffect(() => {
    // refetch();
    if (user) {
      refetch(userParams);
    }
  }, [page, page_size, formSubmitParams, user]);

  useEffect(() => {
    if (exportAction == true && dataExport != undefined)
      generateExcel(dataExport);
  }, [dataExport, exportAction]);

  function handleCheckboxChange(record: any, checked: boolean) {
    if (checked) {
      if (
        !listShopSelected.some(
          (item: any) => item.ma_cua_hang === record.ma_cua_hang
        )
      ) {
        setListShopSelected([...listShopSelected, record]);
        listShopSelected.length + 1 == lstAllShops?.length && setCheckAll(true);
      }
    } else {
      const updatedList = listShopSelected.filter(
        (item: any) => item.ma_cua_hang !== record.ma_cua_hang
      );
      setListShopSelected(updatedList);
      setCheckAll(false);
      // console.log(listShopSelected);
    }
  }

  const sortData = [
    'Mới nhất',
    'Bán chạy',
    'Đăng ký kỳ trước',
    'Sức bán trung bình',
  ];

  const columnTops: ColumnsType<any> = [
    {
      title: 'Tủ Xman',
      dataIndex: 'tuXman',
      width: 90,
      render: (value) => value ?? '-',
    },
    {
      title: 'Đơn vị tính',
      dataIndex: 'dVi',
      width: 60,
      render: (value) => value ?? '-',
    },
    {
      title: 'Tủ',
      dataIndex: 'tu',
      width: 30,
      render: (value) => value ?? '-',
    },
    {
      title: 'SL Mẫu',
      dataIndex: 'sLMau',
      width: 30,
      render: (value) => value ?? '-',
    },
    {
      title: 'Min kế hoạch',
      dataIndex: 'minPlan',
      width: 60,
      render: (value) => value ?? '-',
    },
    { title: 'Min hiện tại', dataIndex: 'minCur', width: 60 },
    {
      title: 'Min đã duyệt',
      dataIndex: 'minApproval',
      width: 60,
      render: (value) => value ?? '-',
    },
    {
      title: 'Max kế hoạch',
      dataIndex: 'maxPlan',
      width: 60,
      render: (value) => value ?? '-',
    },
    {
      title: 'Max hiện tại ',
      dataIndex: 'maxCur',
      width: 60,
      render: (value) => value ?? '-',
    },
    {
      title: 'Max đã duyệt',
      dataIndex: 'maxApproval',
      width: 60,
      render: (value) => value ?? '-',
    },
  ];

  const columnBottoms: ColumnsType<any> = [
    {
      dataIndex: 'redflag',
      width: 35,
      render: (_: any, record) => '', //<RedFlag />
    },
    {
      title: 'STT',
      dataIndex: 'stt',
      width: 60,
      render: (value, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã cửa hàng',
      dataIndex: 'ma_cua_hang',
      width: 120,
    },
    {
      title: 'Tên cửa hàng',
      dataIndex: 'ten_cua_hang',
      width: 180,
    },
    {
      title: 'Trạng thái đơn hàng',
      dataIndex: 'order_status',
      width: 160,
      render: (_: any, record: any) => {
        return convertStatusApproveOrder(record?.order_status);
      },
    },
    {
      title: 'Trạng thái phê duyệt của ASM',
      dataIndex: 'asm_approve_status',
      width: 210,
      render: (value: any, record: any) => {
        return value == undefined || value == null
          ? '-'
          : value == 0
          ? 'Chưa duyệt'
          : value == 1
          ? 'Đã duyệt'
          : 'Từ chối';
      },
    },
    { title: 'SL mẫu kế hoạch', dataIndex: '', width: 140 },
    { title: 'SL mẫu đăng ký', dataIndex: 'sl_dk_mau', width: 130 },
    {
      title: 'Vốn min đăng ký',
      dataIndex: 'von_min',
      width: 130,
      render: (_: any, record: any) => formatCurrencyVND(record.von_min),
    },
    { title: 'Vốn Max kế hoạch', dataIndex: '', width: 140 },
    {
      title: 'Vốn Max đăng ký ',
      dataIndex: 'von_max',
      width: 140,
      render: (_: any, record: any) => formatCurrencyVND(record.von_max),
    },
    { title: 'Min kế hoạch (món)', dataIndex: '', width: 150 },
    { title: 'Min đăng ký (món)', dataIndex: 'sl_dk_min', width: 150 },
    { title: 'Max kế hoạch (món)', dataIndex: '', width: 155 },
    { title: 'Max đăng ký (món)', dataIndex: 'sl_dk_max', width: 150 },
    { title: 'Quận Huyện', dataIndex: 'district', width: 120 },
    { title: 'Tier', dataIndex: 'tier_name', width: 100 }, //tier || tier_name
    {
      title: 'Mô Hình Kinh Doanh',
      dataIndex: 'mo_hinh_kinh_doanh',
      width: 160,
    },
    { title: 'Cấp cửa hàng', dataIndex: 'cap_cua_hang', width: 140 },
    {
      title: 'Ngày đăng ký',
      dataIndex: 'created_at',
      width: 130,
      render: (_: any, record: any) =>
        moment(record.created_at).format('DD/MM/YYYY'),
    },
    {
      title: 'Ngày phê duyệt',
      dataIndex: 'approve_date',
      width: 130,
      render: (_: any, record: any) =>
        record.approve_date
          ? moment(record.approve_date).format('DD/MM/YYYY')
          : '',
    },
    { title: 'Người yêu cầu', dataIndex: 'created_by', width: 160 },
    { title: 'Lần phê duyệt', dataIndex: '', width: 120 }, //ko bt lần phê duyệt
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: user?.plantCode == 1000 ? 120 : 160,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          {user?.plantCode == 1000 ? (
            <button>
              <EyeIcon2 />
            </button>
          ) : (
            <>
              <button
                onClick={() =>
                  history.push(`/detail-approve-order-list`, {
                    order_shop: record,
                    cart: cart,
                  })
                }
              >
                <EyeIcon2 />
              </button>

              <button onClick={() => checkApproveRejectShop(record, true)}>
                {(
                  user?.role.includes('asm')
                    ? record.asm_approve_status == 0
                    : record.order_status == 1
                ) ? (
                  <CheckIcon />
                ) : (
                  <CheckGray />
                )}
              </button>

              {/* <button onClick={() => checkApproveRejectShop(record, false)}>
                <Remove />
              </button> */}
            </>
          )}
        </div>
      ),
    },
  ];

  function handleCheckBoxAll(e: CheckboxChangeEvent) {
    // !lstAllShops && getAllShops();
    if (e.target.checked) {
      const updatedData = lstAllShops
        .map((value: any) => value.order_status)
        .filter((value: any) => value == 1);

      if (updatedData?.length == 0) {
        openNotificationWithIcon('error', `Không có cửa hàng nào chờ duyệt`);
        setCheckAll(false);
        setListShopSelected([]);
      } else {
        setCheckAll(true);
        setListShopSelected(updatedData);
      }
    } else {
      setListShopSelected([]);
      setCheckAll(e.target.checked);
    }
  }

  {
    user?.plantCode != 1000 &&
      columnBottoms.unshift({
        title: (
          <Checkbox
            checked={checkAll}
            onChange={(e) => {
              if (checkAll) {
                setCheckAll(false);
                setListShopSelected([]);
              } else {
                getAllShops({
                  ...userParams,
                  page_size: lstAllocation?.total,
                  action: 'checkAll',
                  eventChechBox: e,
                });
              }
            }}
          />
        ),
        dataIndex: 'isSelected',
        width: 30,
        align: 'center',
        render: (text, record) => (
          <Checkbox
            disabled={
              user?.role.includes('asm')
                ? record.asm_approve_status != 0
                : record.order_status != 1
            }
            checked={
              listShopSelected
                .map((item: any) => item.ma_cua_hang)
                .includes(record.ma_cua_hang) || checkAll
            }
            onChange={(e) => handleCheckboxChange(record, e.target.checked)}
          />
        ),
      });
  }

  const items_top: CollapseProps['items'] = [
    {
      key: '1',
      label: (
        <p className="text-base font-bold text-primary-50 ml-2">
          Vốn theo dòng hàng
        </p>
      ),
      children: (
        <div>
          <Table
            rowKey={(record) => record.id}
            columns={columnTops}
            size="small"
            className="customTable"
            dataSource={capitalLineProduct}
            scroll={{ x: 958 }}
            //  loading={getAllocationLoading}
            pagination={false}
          />
        </div>
      ),
    },
  ];

  const handleChange = (tag: string, checked: boolean) => {
    if (tag == selectedTags) {
      setSelectedTags(undefined);
    } else {
      setSelectedTags(tag);
    }
  };

  const exportMultiStore = async (param: any) => {
    try {
      const response = await CartApi.exportMultiStore(param);
      setIsLoading(false);
      return response.data; // Trả về dữ liệu từ API
    } catch (error) {
      setIsLoading(false);
      console.error('Export thất bại:', error);
      return [];
    }
  };

  const handleExport = async () => {
    setDataExport(undefined);
    setExportAction(false);
    getAllShops({
      ...userParams,
      page_size: lstAllocation?.total,
      action: 'export',
    });
  };

  function generateExcel(dataExport: any) {
    const data = [];

    // create title
    const header = headerRow.map((column) => {
      return column.title;
    });

    data.push(header);

    const itemExport = Object.values(dataExport);

    // create data
    itemExport.forEach((prm) => {
      const rowData = headerRow.map((column) => {
        if (prm != undefined) {
          if (column.dataIndex == 'status') {
            const data =
              prm[column.dataIndex] == 0
                ? 'mới tạo'
                : prm[column.dataIndex] == 1
                ? 'CHT Duyệt và gửi CN'
                : prm[column.dataIndex] == 2
                ? 'CN duyệt'
                : prm[column.dataIndex] == 3
                ? 'CN Từ chối'
                : prm[column.dataIndex] == 4
                ? 'HS Duyệt'
                : 'HS Từ Chối';
            return data;
          } else if (
            column.dataIndex == 'date_started' ||
            column.dataIndex == 'date_end' ||
            column.dataIndex == 'create_at' ||
            column.dataIndex == 'request_date'
          ) {
            const data = prm[column.dataIndex]
              ? prm[column.dataIndex].slice(0, 10)
              : '';
            return data;
          } else if (column.dataIndex == 'size') {
            if (prm[column.dataIndex] != undefined) {
              return prm[column.dataIndex]?.length != 0
                ? prm[column.dataIndex][0].value
                : '';
            }
          } else if (
            column.dataIndex == 'area_code' ||
            column.dataIndex == 'plant_code'
          ) {
            return prm[column.dataIndex] ? prm[column.dataIndex] : '';
          } else if (
            !isNaN(prm[column.dataIndex]) &&
            !isNaN(parseFloat(prm[column.dataIndex]))
          )
            return Number(prm[column.dataIndex]);
          return prm[column.dataIndex]
            ? prm[column.dataIndex]?.toString()
            : '-';
        }
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Đơn hàng đăng ký.xlsx`);
  }

  function exportFileExcel(dataExport: any) {
    const data = [];
    let index = 0;
    const headerRow = columnBottoms
      .filter(
        (column) =>
          column.dataIndex !== 'isSelected' && column.dataIndex != undefined
      )
      .map((column) => {
        if (column.dataIndex === 'redflag') {
          return 'Đánh dấu';
        } else {
          return column.title;
        }
      });
    data.push(headerRow);
    console.log(dataExport);
    dataExport?.forEach((shop: any) => {
      const rowData = columnBottoms
        .filter(
          (column) =>
            column.dataIndex !== 'isSelected' && column.dataIndex != undefined
        )
        .map((column) => {
          switch (column.dataIndex) {
            case 'stt':
              return ++index;
            case 'order_status':
              return convertStatusApproveOrder(shop[column.dataIndex]);
            case 'total_capital_max':
            case 'total_capital_min':
              return formatCurrencyVND(shop[column.dataIndex]);
            default:
              return shop[column.dataIndex];
          }
        });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `phe_duyet_chi_nhanh.xlsx`);
  }

  function changeSelectSort() {
    console.log('changeSelectSort');
  }

  function goBack() {
    console.log('Function not implemented.');
  }

  function checkApproveRejectShop(record: any, isApprove: boolean) {
    if (user?.role.includes('asm')) {
      if (record.asm_approve_status == 0) {
        setModalOpen(true);
        setIsApprove(isApprove);
        setIsManyApprove(false);
        setShopHandle(record);
      } else {
        openNotificationWithIcon(
          'error',
          `Cửa hàng này ${
            record.asm_approve_status == 1 ? 'Đã duyệt' : 'Từ chối'
          }`
        );
      }
    } else {
      if (record.order_status == 1) {
        setModalOpen(true);
        setIsApprove(isApprove);
        setIsManyApprove(false);
        setShopHandle(record);
      } else {
        openNotificationWithIcon(
          'error',
          `Cửa hàng này ${convertStatusApproveOrder(record.order_status)}`
        );
      }
    }
  }

  function hanldeApproveShop(isApprove: boolean) {
    if (listShopSelected.length != 0) {
      setModalOpen(true);
      setIsApprove(isApprove);
      setIsManyApprove(true);
    } else {
      openNotificationWithIcon('error', `Chưa chọn cửa hàng`);
    }
  }

  async function ApprovalRejectShop() {
    setIsLoading(true);
    if (isManyApprove && listShopSelected.length != 0) {
      for (let i = 0; i < listShopSelected.length; i++) {
        await CartApi.updateStatusCart_CHT({
          id: cart.id,
          id_cart_order_cht: listShopSelected[i].cart_order_cht_id,
          status: isApprove
            ? user?.role.includes('asm')
              ? 1
              : 2
            : user?.role.includes('asm')
            ? 2
            : 3,
        }).catch((err) => {
          openNotificationWithIcon('error', err.toString());
        });
      }
      openNotificationWithIcon(
        'success',
        `${isApprove ? 'Phê duyệt' : 'Từ chối'} thành công`
      );

      setModalOpen(false);
      setIsLoading(false);
      setListShopSelected([]);
      setCheckAll(false);
      refetch(userParams);
    } else {
      CartApi.updateStatusCart_CHT({
        id: cart.id,
        id_cart_order_cht: shopHandle?.cart_order_cht_id,
        status: isApprove
          ? user?.role.includes('asm')
            ? 1
            : 2
          : user?.role.includes('asm')
          ? 2
          : 3,
      })
        .then((res) => {
          openNotificationWithIcon(
            'success',
            `${isApprove ? 'Phê duyệt' : 'Từ chối'} thành công`
          );
          setModalOpen(false);
          setIsLoading(false);
          setListShopSelected(
            listShopSelected.filter(
              (value: any) => value != shopHandle?.cart_order_cht_id
            )
          );
          refetch(userParams);
        })
        .catch((err) => {
          openNotificationWithIcon('error', err.toString());
        });
    }
  }

  return (
    <Spin spinning={isLoadingAllShop || isLoading}>
      {/* <Row>
        <Col span={24} className="border-2 mb-5 border-blue-100">
          <Collapse
            expandIconPosition="right"
            ghost
            expandIcon={({ isActive }) =>
              isActive ? <ChevronUp /> : <ChevronDown />
            }
            size="small"
            items={items_top}
          />
        </Col>
      </Row> */}
      <Row
        justify={'space-between'}
        style={{
          paddingBottom: '10px',
          paddingLeft: '18px',
          paddingRight: '0px',
          alignItems: 'center',
        }}
      >
        <Row gutter={25} align={'middle'}></Row>
        <Space>
          <Button
            bgColor={'white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
            onClick={handleExport}
          >
            <DownloadIcon /> Tải file Excel
          </Button>
          {/* <Button
            bgColor={'white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
          >
            <FilterIcon2 /> Lọc
          </Button>
          <Select
            placeholder="Sắp xếp nâng cao"
            className="w-full"
            allowClear
            value={bstSelected}
            onChange={(value) => {
              setBST(value);
              changeSelectSort();
            }}
          >
            {PORTFOLIO_STATUS.map((item) => (
              <Option value={item.values} key={item.name} defaultValue={null}>
                {item.name}
              </Option>
            ))}
          </Select> */}
        </Space>
      </Row>
      <Table
        rowKey={(record) => record.ma_cua_hang}
        columns={columnBottoms}
        size="middle"
        className="customTable mt-2"
        dataSource={lstAllocation?.data}
        scroll={{ x: 958 }}
        loading={getAllocationLoading}
        pagination={{
          className: 'flex items-center',
          current: page,
          pageSize: page_size,
          total: lstAllocation?.total,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '50'],
          onChange: HocChangePagination(history),
        }}
      />
      {user?.plantCode != 1000 && (
        <div
          className="-mx-7 -mb-3 pr-3 pt-1"
          style={{ backgroundColor: '#f1f9ff' }}
        >
          <Row justify={'end'} className="mt-5 -mr-2 pb-8">
            <Space>
              <Button
                bgColor={'white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                onClick={goBack}
              >
                Trở lại
              </Button>
              {/* <Button
                bgColor={'bg-red-500'}
                color={'text-white'}
                onClick={() => hanldeApproveShop(false)}
              >
                Từ chối
              </Button> */}
              <Button
                bgColor={'bg-[#038F00]'}
                color={'text-white'}
                onClick={() => hanldeApproveShop(true)}
              >
                <span>Phê duyệt</span>
              </Button>
            </Space>
          </Row>
        </div>
      )}

      {/* phê duyệt, từ chối cửa hàng */}
      <Modal
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
        }}
        footer={null}
        width={'50%'}
      >
        <Content className="w-full">
          <p className="text-2xl font-bold">
            Phê duyệt {isManyApprove ? 'hàng loạt' : ''} cửa hàng
          </p>
          <Divider style={{ margin: '20px 0' }} />
          <div>
            <p className="text-base">
              Bạn có chắc muốn {isApprove ? 'phê duyệt' : 'từ chối'} cửa hàng:{' '}
              <span className="font-bold">
                {isManyApprove
                  ? listShopSelected
                      .map((value: any) => value.ten_cua_hang)
                      .join(', ')
                  : shopHandle?.ten_cua_hang}
              </span>
            </p>
          </div>
          <Row justify="end" className="mt-4">
            <Button
              onClick={() => {
                setModalOpen(false);
              }}
              customClass="text-neutral-50 mr-2"
              bgColor="white"
            >
              Huỷ
            </Button>
            <Button
              onClick={ApprovalRejectShop}
              bgColor={isApprove ? 'bg-green-400' : 'bg-red-500'}
              color={'text-white'}
            >
              {isApprove ? 'Phê duyệt' : 'Từ chối'}
            </Button>
          </Row>
        </Content>
      </Modal>
    </Spin>
  );
}
